var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import _ from 'lodash';
import classnames from 'classnames';
import { ICON_PREFIX, ICON_PREFIX_DEPRECATED, DEFAULT_WIDTH } from './constants';
export var getIconSettledProps = function (props) {
    var _a, _b, _c, _d;
    var name = props.name, _e = props.width, width = _e === void 0 ? DEFAULT_WIDTH : _e, height = props.height, className = props.className, _f = props.fill, fill = _f === void 0 ? 'currentColor' : _f, rotate = props.rotate, animation = props.animation, restProps = __rest(props, ["name", "width", "height", "className", "fill", "rotate", "animation"]);
    var spanClassName = classnames(ICON_PREFIX, ICON_PREFIX_DEPRECATED, (_a = {}, _a["".concat(ICON_PREFIX, "-").concat(name)] = !!name, _a), (_b = {}, _b["".concat(ICON_PREFIX_DEPRECATED, "-").concat(name)] = !!name, _b), (_c = {}, _c["".concat(ICON_PREFIX, "-animation-").concat(animation)] = !!animation, _c), (_d = {}, _d["".concat(ICON_PREFIX_DEPRECATED, "-animation-").concat(animation)] = !!animation, _d), className);
    var svgStyle = _.isNumber(rotate) ? { transform: "rotate(".concat(rotate, "deg)") } : {};
    return {
        spanProps: __assign({ className: spanClassName }, restProps),
        svgProps: {
            width: width,
            height: height,
            style: svgStyle,
            fill: fill
        }
    };
};
